import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compsa',
  templateUrl: './compsa.component.html',
  styleUrls: ['./compsa.component.scss']
})
export class CompsaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

};


